import react, { useEffect } from 'react'
import styled from 'styled-components'
import { Mentor } from '../../../models/User'
import MentorLine from '../../Common/MentorLine'
import { Card, CardContent, CardTitle } from '../../Layout/CommonStyle'

type MentorListParam = {
  mentors: Mentor[]
  selectMentorIndex: number
  selectedMentors: Mentor[]
  selectMentor: (index: number) => void
}

function LeftSide(props: MentorListParam) {
  useEffect(() => {
    props.selectMentor(-1)
  }, [])

  return (
    <Container>
      <Card>
        <CardTitle>추천</CardTitle>
        <CardContent>
          <MentorLine
            key={-1}
            id={-1}
            name="전체"
            // group="전체"
            selected={props.selectMentorIndex === -1}
            onClick={() => props.selectMentor(-1)}
          />
          {props.mentors &&
            props.mentors.map((m, index) => (
              <MentorLine
                key={index}
                id={m.mentor.id}
                name={m.mentor.username + ' (멘토)'}
                // group={m.mentor.groupName}
                selected={index === props.selectMentorIndex}
                onClick={() => props.selectMentor(index)}
              />
            ))}
          <MentorLine
            key={-2}
            id={-1}
            name="친구들"
            // group="전체"
            selected={props.selectMentorIndex === -2}
            onClick={() => props.selectMentor(-2)}
          />
        </CardContent>
      </Card>
    </Container>
  )
}

const Container = styled.div`
  grid-area: leftside;

  @media (max-width: 768px) {
    display: none;
  }
`

export default LeftSide
